module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presence-panel"
  }, [_c('div', {
    staticClass: "head"
  }, [(_vm.day) ? _c('div', {
    staticClass: "dateDisplay"
  }, [(_vm.user.is_board_member || _vm.user.can_lookup_shift_times) ? _c('div', {
    staticClass: "button dateButton",
    on: {
      "click": function($event) {
        return _vm.changeDate()
      }
    }
  }, [_vm._v("<")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.day.date, "DD. MM. YYYY")))]), (_vm.user.is_board_member || _vm.user.can_lookup_shift_times) ? _c('div', {
    staticClass: "button dateButton",
    attrs: {
      "disabled": _vm.isToday
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(true)
      }
    }
  }, [_vm._v(">")]) : _vm._e()]) : _vm._e(), (_vm.day) ? _c('div', {
    staticClass: "events"
  }, [_vm._l((_vm.day.events), function(event) {
    return _c('div', {
      staticClass: "event"
    }, [(!event.canceled) ? [_c('span', [_vm._v(_vm._s(event.badge) + ":")]), _c('span', [_vm._v(" " + _vm._s(event.name))])] : _vm._e()], 2)
  }), (_vm.day.events.length == 0) ? _c('div', [_vm._v("heute keine Veranstaltung")]) : _vm._e()], 2) : _vm._e(), (_vm.day && _vm.day.events.length != 0) ? _c('div', {
    staticClass: "presence-user header"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._m(0), _vm._m(1)]) : _vm._e()]), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.shifts), function(shift, index) {
    return _c('div', {
      staticClass: "shift-type",
      class: {
        'dark-bg': index % 2
      }
    }, [_c('presence-list', {
      attrs: {
        "shift": shift,
        "user": _vm.user
      },
      on: {
        "refresh": function($event) {
          return _vm.loadShifts()
        }
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Start")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Ende")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4147fba"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PresencePanel.vue
// module id = 1090
// module chunks = 1